import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './index.scss';

export const LoadingIndicator = () => {
    return <div className='loading-indicator-container'>
        <FontAwesomeIcon icon={faSpinnerThird} size="6x" color='#9CB560' spin />
    </div>;
}